import * as React from 'react'
import { Button } from '../../components/UI/Button'
import { ButtonBlok } from '../../types'
import CustomLink from '../../components/CustomLink'
import { useI18n } from '../../lib/context/i18n'
import { useButtonTracking } from './useButtonTracking'

export const ButtonModule = ({ blok }: { blok: ButtonBlok }) => {

  const { getTranslatedUrlFromLink } = useI18n()
  const href = getTranslatedUrlFromLink(blok.link)

  const { onClickHandler } = useButtonTracking(blok)

  return (
    <Button
      $variant={blok.button_style}
      as={CustomLink}
      href={href}
      $ignoreTheme={blok.$ignoreTheme}
      iconLeft={blok.iconLeft}
      iconRight={blok.iconRight}
      $inverted={blok.inverted}
      $size={blok.size || 'default'}
      onClick={onClickHandler}
    >
      {blok.button_name}
    </Button>
  )
}
